module.exports = __webpack_public_path__ + "static/media/skinny-logo.029dfae6.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Header/skinny-logo.svg
 ** module id = 473
 ** module chunks = 0
 **/